var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 20.0004C9.01536 19.9975 6.47348 18.943 4.59874 17.0683C2.724 15.1936 1.66951 12.6517 1.66664 10.0004C1.53914 2.53707 10.0258 -2.4871 16.4925 1.2579L17.7866 1.97623L16.5008 2.70957C10.9175 5.7829 11.3258 14.2679 17.1675 16.7979L18.5183 17.4071L17.2958 18.2454C15.6403 19.3866 13.6774 19.9986 11.6666 20.0004Z",
    fill: "#F9F6FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.93408a5e31d652d54f7b1adcef7eaa0c.svg";
export { ForwardRef as ReactComponent };